module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "filebox"
    }
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Files")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTabName),
      callback: function($$v) {
        _vm.activeTabName = $$v
      },
      expression: "activeTabName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "My Files",
      "name": "myFiles"
    }
  }, [_c('filebox-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingMyFiles),
      expression: "loadingMyFiles"
    }],
    attrs: {
      "element-loading-text": "Loading your files...",
      "files": _vm.myFiles,
      "icons": _vm.icons
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Company Files",
      "name": "companyFiles"
    }
  }, [_c('filebox-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingCompanyFiles),
      expression: "loadingCompanyFiles"
    }],
    attrs: {
      "element-loading-text": "Loading company files...",
      "files": _vm.companyFiles,
      "icons": _vm.icons
    }
  })], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c864fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/filebox/FileboxList.vue
// module id = 3121
// module chunks = 3